import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {PassengerPoliciesContent as SharedPassengerPolicies} from "@/customComponents/globalComponents/policiesContent.jsx";
import {bookingPolicyValues} from "@/customComponents/globalComponents/policyValues.js";

// Booking-flow adapter: shared content with values from /trips/calculate-policies.
export function PassengerPoliciesContent() {
    return <SharedPassengerPolicies policy={bookingPolicyValues()}/>;
}

export function PassengerPolicies({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing"} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <PassengerPoliciesContent/>
        </>
    );
}
export default PassengerPolicies;
